import { format } from "date-fns";
import { OrangeButton, RouteButton } from "../../Buttons";
import { MonthLayout } from "./MonthLayout";
import { CalendarProps } from "@/interfaces/calendar_type";

type FullCalendarProps = {
    currentMonth: Date
    handlePrevMonth: () => void
    handleNextMonth: () => void
    daysInMonth: number
    projectsDueToday: CalendarProps[]
}

export function FullCalendar({ currentMonth, handlePrevMonth, handleNextMonth, daysInMonth, projectsDueToday }: FullCalendarProps) {
    return (
        <>
            <div className="my-5 mx-auto rounded-lg p-6">
                <div className="flex justify-between mb-4">
                    <OrangeButton onClick={handlePrevMonth} className='p-4 bg-orange-300 rounded hover:bg-orange-400 transition'>
                        Previous
                    </OrangeButton>

                    <h2 className="text-2xl font-semibold">
                        {format(currentMonth, 'MMMM yyyy')}
                    </h2>

                    <OrangeButton onClick={handleNextMonth} className='p-4 bg-orange-300 rounded hover:bg-orange-400 transition'>
                        Next
                    </OrangeButton>
                </div>

                <div className="grid grid-cols-7 gap-2">
                    <h4 className="text-center">Sun</h4>
                    <h4 className="text-center">Mon</h4>
                    <h4 className="text-center">Tue</h4>
                    <h4 className="text-center">Wed</h4>
                    <h4 className="text-center">Thu</h4>
                    <h4 className="text-center">Fri</h4>
                    <h4 className="text-center">Sat</h4>
                </div>

                <MonthLayout daysInMonth={daysInMonth} currentMonth={currentMonth} projectList={projectsDueToday} />

            </div>

            <div className="flex justify-center mt-4">
                <RouteButton route="/main_menu" text="Back to Main Menu" />
            </div>
        </>
    );
}
